import PropTypes from 'prop-types'

import {Map} from 'immutable'
import {useState} from 'react'
import {connect} from 'react-redux'
import {deleteResource} from 'redux-json-api'

import ConfirmationModal from '../../../../shared_components/mui_base_components/modals/confirmation_modal/ConfirmationModal'
import MixpanelLogger from '../../../../lib/MixpanelLogger'
import {useNotificationContext} from '../../../../shared_components/notifications/NotificationContext'
import SendEmailIcon from '../icons/SendEmailIcon'
import TrashCanIcon from '../icons/TrashCanIcon'
import AddDeputyModal from './add/AddDeputyModal'
import DeputyPermissionsSummary from './permissions/DeputyPermissionsSummary'

import {BoxGutterSmall} from '../blocks/Boxes'
import {Text, TextGutterSmall} from '../blocks/Texts'
import UserAvatar from '../../../../shared_components/mui_base_components/avatar/UserAvatar'

const DraftDeputyBox = ({
  draftDeputy,
  onDraftDeputyRemoved,
  onDraftDeputyReviewed,
  ...otherProps
}) => {
  const [isAddDeputyModalVisible, setIsAddDeputyModalVisible] = useState(false)
  const [isRemovingDraftDeputy, setIsRemovingDraftDeputy] = useState(false)

  const [
    isRemoveConfirmationModalVisible,
    setIsRemoveConfirmationModalVisible
  ] = useState(false)
  const {alwaysNotify} = useNotificationContext()

  const confirmRemove = () => {
    setIsRemoveConfirmationModalVisible(true)
  }

  const closeRemoveConfirmationModal = () => {
    if (!isRemovingDraftDeputy)
      setIsRemoveConfirmationModalVisible(false)
  }

  const handleRemove = () => {
    setIsRemovingDraftDeputy(true)

    otherProps.deleteResource({
      type: 'draft-deputies',
      id: draftDeputy.get('id')
    }).then(() => {
      setIsRemovingDraftDeputy(false)
      setIsRemoveConfirmationModalVisible(false)

      onDraftDeputyRemoved()
    })
      .catch(() => {
        setIsRemovingDraftDeputy(false)

        alwaysNotify.shortError('Unable to remove this Deputy invitation. Please try again.')
      })
  }

  const handleReview = () => {
    MixpanelLogger.track('click_add_deputy', {
      context: otherProps.context,
      deputy_count: otherProps.deputies?.size,
      source: 'concierge'
    })

    setIsAddDeputyModalVisible(true)
  }

  return (
    <>
      <BoxGutterSmall className='draft-deputy-box flex-container flex-child'>
        <div className='flex-child flex-container deputy-item'>
          <section className='flex-child'>
            <UserAvatar user={draftDeputy} />
            <div className='full-name'>
              {
                `${draftDeputy.get('first-name')}
                ${draftDeputy.get('last-name')}`
              }
            </div>
            <Text className='thin-text small-text'>
              {draftDeputy.get('email')}
            </Text>
          </section>
          <section
            className={`
              action-bar
              destroy-action
              flex-child
              flex-container
            `}
            onClick={confirmRemove}>
            <TrashCanIcon />
            Remove
          </section>
        </div>
        <DeputyPermissionsSummary
          deputy={draftDeputy}
          isDraftDeputy={true}
          {...otherProps}
        />
        <div className='flex-child flex-container deputy-item'>
          <section className='flex-child status'>
            <div className='section-header-text'>Status</div>
            <div className='section-details'>
              <TextGutterSmall className='draft'>Draft</TextGutterSmall>
              <TextGutterSmall className='thin-text'>
                Added by Everplans Concierge
              </TextGutterSmall>
            </div>
          </section>
          <section
            className={`
              action-bar
              flex-child
              flex-container
              update-action
            `}
            onClick={handleReview}>
            <SendEmailIcon />
            Review & Send
          </section>
        </div>
      </BoxGutterSmall>
      <ConfirmationModal
        confirmButtonText='Remove'
        headingText='Remove this Deputy invitation?'
        loading={isRemovingDraftDeputy}
        onClose={closeRemoveConfirmationModal}
        onConfirmation={handleRemove}
        open={isRemoveConfirmationModalVisible}
      />
      {
        isAddDeputyModalVisible && (
          <AddDeputyModal
            draftDeputy={draftDeputy}
            exit={() => setIsAddDeputyModalVisible(false)}
            onDraftDeputyReviewed={onDraftDeputyReviewed}
            {...otherProps}
            source='concierge'
          />
        )
      }
    </>
  )
}

DraftDeputyBox.propTypes = {
  draftDeputy: PropTypes.instanceOf(Map).isRequired,
  onDraftDeputyRemoved: PropTypes.func.isRequired,
  onDraftDeputyReviewed: PropTypes.func.isRequired
}

export default connect(null, {deleteResource})(DraftDeputyBox)
